import * as React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslator } from '@gandi/translate';
import Item from './Item';
import { getDescriptionLabel, NO_PRICE, useDetails, useGetTotalPrice, useGetComputedTotalPrice } from './helpers';
import { removeProductFactory } from './modules/actions';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ProductItem({
  product
}) {
  const translator = useTranslator();
  const dispatch = useDispatch();
  const getTotalPrice = useGetTotalPrice();
  const getComputedTotalPrice = useGetComputedTotalPrice();
  const details = useDetails({
    product,
    isWidget: true
  });
  const {
    productType,
    payload,
    process,
    quantity,
    identifier,
    label,
    prices
  } = product;
  let price = NO_PRICE;
  if (product.computedTotalPrices && quantity > 1) {
    price = getComputedTotalPrice(product.computedTotalPrices);
  } else if (product.total) {
    price = getTotalPrice(product.total);
  }
  if (!!product.discounts?.length && product.total?.before_discount !== undefined) {
    price = getComputedTotalPrice(product.computedTotalPrices);
  }
  return /*#__PURE__*/_jsx(Item, {
    price: price ?? NO_PRICE,
    title: getDescriptionLabel({
      translator,
      productType,
      payload,
      process,
      quantity,
      identifier,
      label,
      prices
    }),
    details: details,
    handleRemoveAction: removeProductFactory({
      translator,
      dispatch,
      product
    }),
    productType: productType,
    process: process,
    payload: payload
  });
}